import React from "react";

import { getProps, STYLES } from "./constants";
import ZIcon from "../ZIcon/ZIcon";
import VariableRenderer from "./VariableRenderer";

const TextSegment = ({ childSegments = [], variables = {} }) => {
  return childSegments.map((child, index) => {
    const otherProps = child.children?.reduce(
      (acc, { type, ...rest }) => ({
        ...acc,
        ...(getProps[type]?.(rest) ?? {}),
      }),
      {},
    );
    switch (child.type) {
      case STYLES.BOLD:
        return (
          <b key={index} {...otherProps}>
            <TextSegment childSegments={child.children} variables={variables} />
          </b>
        );
      case STYLES.UNORDERED_LIST:
        return (
          <ul {...otherProps}>
            <TextSegment
              key={index}
              childSegments={child.children}
              variables={variables}
            />
          </ul>
        );
      case STYLES.ORDERED_LIST:
        return (
          <ol {...otherProps}>
            <TextSegment
              key={index}
              childSegments={child.children}
              variables={variables}
            />
          </ol>
        );
      case STYLES.LIST_ITEM:
        return (
          <li key={index} {...otherProps}>
            <TextSegment
              key={index}
              childSegments={child.children}
              variables={variables}
            />
          </li>
        );
      case STYLES.SPAN:
        return (
          <span key={index} {...otherProps}>
            <TextSegment
              key={index}
              childSegments={child.children}
              variables={variables}
            />
          </span>
        );
      case STYLES.DIV:
        return (
          <div key={index} {...otherProps}>
            <TextSegment
              key={index}
              childSegments={child.children}
              variables={variables}
            />
          </div>
        );
      case STYLES.SRC: {
        const { src, width, height } = otherProps || {};
        if (!src) return null;
        return (
          <img
            key={index}
            src={src}
            width={width}
            height={height}
            alt=""
            style={{ maxWidth: "100%", height: height ? undefined : "auto" }}
          />
        );
      }
      case STYLES.ICON:
        return <ZIcon key={index} {...otherProps} />;
      case STYLES.ANCHOR:
        return (
          <a key={index} {...otherProps}>
            <TextSegment
              key={index}
              childSegments={child.children}
              variables={variables}
            />
          </a>
        );
      case STYLES.VARIABLE: {
        const varId = child.value;
        const varConfig = variables?.[varId];

        // Render the animation if config is valid
        if (varConfig && typeof varConfig === "object") {
          return <VariableRenderer key={index} id={varId} config={varConfig} />;
        }

        // FALLBACK: If config is missing, force a visible red tag so we know it mounted
        return (
          <span
            key={index}
            data-variable-id={varId}
            style={{ color: "red", fontWeight: "bold" }}
          >
            [Missing Config: {varId}]
          </span>
        );
      }
      default:
        return <React.Fragment key={index}>{child.value}</React.Fragment>;
    }
  });
};

export default TextSegment;
